var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path, _path2, _path3, _path4, _rect18, _rect19, _mask, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoRecordLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 276,
    viewBox: "0 0 364 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 126.5,
    y: 78.5,
    width: 156,
    height: 197,
    rx: 13.5,
    fill: "white",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 237,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 19,
    width: 160,
    height: 233,
    rx: 14,
    fill: "#C2C2C2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 84.5,
    y: 6.5,
    width: 159,
    height: 232,
    rx: 13.5,
    fill: "white",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 29,
    width: 116,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 45,
    width: 116,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 61,
    width: 116,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 141,
    width: 116,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 161,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 193,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 260,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 193,
    width: 67,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 260,
    width: 67,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 161,
    width: 64,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 177,
    width: 116,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 209,
    width: 116,
    height: 8,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 61,
    width: 88,
    height: 8,
    rx: 4,
    transform: "rotate(90 114 61)",
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 134C153.333 128.5 168.3 120.8 181.5 134",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.948 142.439C237.136 142.879 237.745 144.201 237.262 145.372C232.965 155.768 225.935 164.826 216.9 171.575C207.251 178.781 195.726 183.047 183.71 183.858C171.694 184.669 159.7 181.992 149.17 176.148C138.64 170.303 130.023 161.542 124.355 150.916C118.687 140.29 116.21 128.253 117.221 116.252C118.232 104.252 122.688 92.7992 130.055 83.2717C137.421 73.7442 147.383 66.5477 158.742 62.5479C169.379 58.8023 180.818 58.0093 191.845 60.2314C193.087 60.4816 193.845 61.7241 193.55 62.9558C193.254 64.1875 192.017 64.9416 190.774 64.695C180.607 62.677 170.069 63.4225 160.265 66.8745C149.74 70.5807 140.509 77.2491 133.684 86.0773C126.858 94.9056 122.728 105.518 121.791 116.638C120.855 127.757 123.15 138.911 128.402 148.757C133.654 158.603 141.639 166.722 151.396 172.137C161.153 177.552 172.267 180.033 183.401 179.281C194.535 178.53 205.214 174.577 214.155 167.9C222.482 161.68 228.971 153.343 232.958 143.775C233.445 142.606 234.76 141.998 235.948 142.439Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.409 64.6804C199.827 63.4849 201.138 62.8514 202.317 63.3138C205.557 64.5843 208.685 66.1231 211.669 67.9142C212.755 68.5662 213.052 69.9909 212.361 71.0523C211.67 72.1136 210.251 72.4094 209.163 71.7606C206.49 70.1665 203.693 68.7905 200.799 67.6459C199.621 67.18 198.99 65.8758 199.409 64.6804Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.576 74.0641C217.356 73.0661 218.801 72.8863 219.77 73.7024C227.939 80.585 234.218 89.4562 237.991 99.4772C241.764 109.498 242.895 120.308 241.294 130.869C241.104 132.122 239.899 132.939 238.655 132.703C237.41 132.468 236.597 131.268 236.784 130.015C238.231 120.282 237.175 110.326 233.699 101.093C230.222 91.8607 224.45 83.6811 216.943 77.319C215.976 76.5001 215.796 75.0621 216.576 74.0641Z",
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 221.727,
    y: 165.5,
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "rotate(-47.982 221.727 165.5)",
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 222.52,
    y: 175.359,
    width: 16.3029,
    height: 61.7561,
    rx: 8.15146,
    transform: "rotate(-45.5039 222.52 175.359)",
    fill: "white",
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-24-outside-1_5995_33105",
    maskUnits: "userSpaceOnUse",
    x: 348,
    y: 78,
    width: 18,
    height: 15,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 348,
    y: 78,
    width: 18,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.892 92L356.112 85.052V86.042L351.072 79.31H353.754L357.426 84.368H356.688L360.342 79.31H363.042L358.002 86.042V85.052L363.204 92H360.504L356.652 86.708H357.444L353.61 92H350.892Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350.892 92L356.112 85.052V86.042L351.072 79.31H353.754L357.426 84.368H356.688L360.342 79.31H363.042L358.002 86.042V85.052L363.204 92H360.504L356.652 86.708H357.444L353.61 92H350.892Z",
    fill: "#C3C3C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M350.892 92L350.092 91.3993L348.89 93H350.892V92ZM356.112 85.052H357.112V82.0561L355.312 84.4513L356.112 85.052ZM356.112 86.042L355.311 86.6413L357.112 89.0463V86.042H356.112ZM351.072 79.31V78.31H349.074L350.271 79.9093L351.072 79.31ZM353.754 79.31L354.563 78.7225L354.264 78.31H353.754V79.31ZM357.426 84.368V85.368H359.388L358.235 83.7805L357.426 84.368ZM356.688 84.368L355.877 83.7824L354.732 85.368H356.688V84.368ZM360.342 79.31V78.31H359.831L359.531 78.7244L360.342 79.31ZM363.042 79.31L363.843 79.9093L365.04 78.31H363.042V79.31ZM358.002 86.042H357.002V89.0463L358.803 86.6413L358.002 86.042ZM358.002 85.052L358.802 84.4527L357.002 82.0478V85.052H358.002ZM363.204 92V93H365.202L364.004 91.4007L363.204 92ZM360.504 92L359.696 92.5885L359.995 93H360.504V92ZM356.652 86.708V85.708H354.687L355.844 87.2965L356.652 86.708ZM357.444 86.708L358.254 87.2947L359.403 85.708H357.444V86.708ZM353.61 92V93H354.12L354.42 92.5867L353.61 92ZM351.692 92.6007L356.912 85.6527L355.312 84.4513L350.092 91.3993L351.692 92.6007ZM355.112 85.052V86.042H357.112V85.052H355.112ZM356.913 85.4427L351.873 78.7107L350.271 79.9093L355.311 86.6413L356.913 85.4427ZM351.072 80.31H353.754V78.31H351.072V80.31ZM352.945 79.8975L356.617 84.9555L358.235 83.7805L354.563 78.7225L352.945 79.8975ZM357.426 83.368H356.688V85.368H357.426V83.368ZM357.499 84.9536L361.153 79.8956L359.531 78.7244L355.877 83.7824L357.499 84.9536ZM360.342 80.31H363.042V78.31H360.342V80.31ZM362.241 78.7107L357.201 85.4427L358.803 86.6413L363.843 79.9093L362.241 78.7107ZM359.002 86.042V85.052H357.002V86.042H359.002ZM357.202 85.6513L362.404 92.5993L364.004 91.4007L358.802 84.4527L357.202 85.6513ZM363.204 91H360.504V93H363.204V91ZM361.312 91.4115L357.46 86.1195L355.844 87.2965L359.696 92.5885L361.312 91.4115ZM356.652 87.708H357.444V85.708H356.652V87.708ZM356.634 86.1213L352.8 91.4133L354.42 92.5867L358.254 87.2947L356.634 86.1213ZM353.61 91H350.892V93H353.61V91Z",
    fill: "#C3C3C3",
    mask: "url(#path-24-outside-1_5995_33105)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M281.5 11.3301L274 7L281.5 2.66987L281.5 11.3301Z",
    stroke: "#C3C3C3",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 219.33L49 215L56.5 210.67L56.5 219.33Z",
    stroke: "#C3C3C3",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.125 14V17.6M69 18.5L65.5 18.5M64.5 18.5L61 18.5M65.125 23L65.125 19.4",
    stroke: "#C3C3C3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M309.125 243V246.6M313 247.5L309.5 247.5M308.5 247.5L305 247.5M309.125 252L309.125 248.4",
    stroke: "#C3C3C3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 122V125.6M8 126.5L4.5 126.5M3.5 126.5L0 126.5M4.125 131L4.125 127.4",
    stroke: "#C3C3C3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144 107.5C146.5 110.833 152.6 115.5 157 107.5",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171 108C173.5 111.333 179.6 116 184 108",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 134.5,
    r: 7.5,
    fill: "#D9D9D9",
    fillOpacity: 0.28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 134.5,
    r: 7.5,
    fill: "#D9D9D9",
    fillOpacity: 0.28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecordLight);
export default __webpack_public_path__ + "static/media/noRecord-light.5a90578fbb0a6eff68a6ade4a31af012.svg";
export { ForwardRef as ReactComponent };